import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import { ReactComponent as AddDottedIcon } from '../../../../../resource/AddDottedIcon.svg';
import DottedBorderBackground from '../../common/DottedBorderBackground/DottedBorderBackground';
import { texts } from '../../../constants/texts';
import styles from './AddInfoBlock.module.scss';

const AddInfoBlock = ({
  className,
  onAddBtnClick,
  text = texts.addInfo,
  iconComponent = AddDottedIcon,
  ...props
}) => {
  return (
    <DottedBorderBackground
      removePadding
      transparent
      className={cn(styles.root, className)}
    >
      <Button
        {...props}
        className={styles.button}
        onClick={onAddBtnClick}
        block
      >
        <Icon component={iconComponent} className={styles.icon} />
        {text}
      </Button>
    </DottedBorderBackground>
  );
};

export default AddInfoBlock;
